export const groupProductPacks = (products) => {
  const groups = new Map();
  products.filter((product) => product.is_active !== false).forEach((product) => {
    const key = product.pack_group_id || product.id;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(product);
  });
  return [...groups.values()].map((packs) => [...packs].sort((a, b) => (a.pack_size_grams || 0) - (b.pack_size_grams || 0)));
};